import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { T_AbflSliceState, T_VerifiedABFLHoldingObj } from "./ABFL_Types";

const initialState: T_AbflSliceState = {
  verifiedPanDetails: [],
};

export const AbflSlice = createSlice({
  name: "AbflSlice",
  initialState,
  reducers: {
    setAbflVerifiedPanDetails: (
      state,
      action: PayloadAction<T_VerifiedABFLHoldingObj[]>,
    ) => {
      return {
        ...state,
        verifiedPanDetails: action.payload,
      };
    },
  },
});

export const AbflSliceReducer = AbflSlice.reducer;
export const AbflSliceKey = AbflSlice.reducerPath;

export const { setAbflVerifiedPanDetails } = AbflSlice.actions;
